import { FormFieldNamesEnum } from './formFieldNamesEnum'

export const trimmers: { [key in FormFieldNamesEnum]?: (arg0: string) => string } = {
  [FormFieldNamesEnum.Email]: val => {
    if (!val) { return '' }
    if (val.length > 5) { return val.trim() }
    return val
  },
  [FormFieldNamesEnum.FirstName]: val => {
    if (!val) { return '' }
    return val.trim()
  },
  [FormFieldNamesEnum.LastName]: val => {
    if (!val) { return '' }
    return val.trim()
  },
  [FormFieldNamesEnum.City]: val => {
    if (!val) { return '' }
    return val.trim()
  },
  [FormFieldNamesEnum.StreetAddressOne]: val => {
    if (!val) { return '' }
    return val.trim()
  },
  [FormFieldNamesEnum.StreetAddressTwo]: val => {
    if (!val) { return '' }
    return val.trim()
  },
  [FormFieldNamesEnum.PostalCode]: val => {
    if (!val) { return '' }
    return val.trim()
  },
  [FormFieldNamesEnum.CompanyName]: val => {
    if (!val) { return '' }
    return val.trim()
  }
}
